export default __webpack_public_path__ + "static/media/grid_section.3b9f6b0c.png";